<template>
	<b-row v-if="modelId > 0 && $hasPermission('reservation.note.show')">
		<b-col>
			<b-overlay :show="loadingNote" no-wrap rounded />
			<FormGroupBox title="Notas">
				<template #append-title>
					<b-button
						v-if="$hasPermission('reservation.note.add')"
						size="sm"
						@click="addNote = true"
						variant="success"
						><md-icon icon="add"
					/></b-button>
				</template>
				<Note
					v-if="addNote"
					:key="0"
					:id="-1"
					:creationDatetime="''"
					:name="user.firstName"
					:optUpdate="true"
					userApp="core"
					:content="''"
					:activeEdit="true"
					:reservation-id="viewModel.id"
					@onSave="onSaveNote"
					@onDelete="onDeleteNote(-1)"
				/>
				<Note
					v-for="(note, index) in notes"
					:key="note.id"
					:id="note.id"
					:userApp="note.user.app"
					:creationDatetime="note.creationDatetime"
					:updateDatetime="note.updateDatetime"
					:name="note.user.firstName"
					:optUpdate="note.user.id == user.id && index == 0"
					:content="note.content"
					:activeEdit="note.id == -1"
					:reservation-id="viewModel.id"
					@onSave="onSaveNote"
					@onDelete="onDeleteNote(note.id)"
				/>
			</FormGroupBox>
		</b-col>
	</b-row>
</template>

<script>
import FormGroupBox from "@/components/helpers/FormGroupBox";
import Note from "../../../reservations/Note";
import api from "@/api.js";
import { mapActions, mapState } from 'vuex';
export default {
	props: {
		modelId: Number
	},
	components: {
		Note,
		FormGroupBox
	},
	data: () => ({
		addNote: false
	}),
	watch: {
		modelId() {
			this.fetchNotes();
		}
	},
	mounted(){
		this.fetchNotes();
	},
	computed: {
		...mapState('reservation',['notes','loadingNote']),
		viewModel() {
			return this.$store.state.reservation.viewModel;
		},
		user() {
			return this.$root.store.state.currentUser;
		}
	},
	methods: {
		...mapActions('reservation',['_fetchNotes']),
		fetchNotes() {
			this._fetchNotes({context:this, modelId:this.modelId});
		},
		onSaveNote() {
			this.addNote = false;
			this.fetchNotes();
		},
		onDeleteNote(noteId){
			if(noteId === -1) this.addNote = false
			else{
				this.$root.showWarning({
					okAction: (event, setLoading, close) => {
						setLoading(true)
						api(this).delete(`/reservation-notes/${noteId}`).then(() => {
							this.$root.showAlert('Nota Eliminada!',{ variant:'warning' })
							this.fetchNotes()
							close()
						}).catch( err => {
							this.$root.handleRequestError(err)
							close()
						});
					}
				})
			}
		},
	}
};
</script>
